import type { Membership } from '../api/types';

/**
 * Enterprise workspace quota, mirrored from the server rule in
 * POST /auth/orgs: an account whose owner holds an ENTERPRISE plan on any
 * owned organization workspace may run up to two organization workspaces;
 * every other plan is limited to one.
 */
export interface WorkspaceQuota {
  /** Organization workspaces this user owns. */
  used: number;
  /** Max organization workspaces this user may own. */
  limit: number;
  /** Whether the user may create another workspace right now. */
  canCreate: boolean;
  /** Whether any owned workspace is on the Enterprise plan. */
  isEnterprise: boolean;
}

export function workspaceQuota(memberships: Membership[]): WorkspaceQuota {
  const owned = memberships.filter(
    (m) => m.kind === 'ORGANIZATION' && m.role === 'OWNER',
  );
  const isEnterprise = owned.some((m) => m.plan === 'ENTERPRISE');
  const limit = isEnterprise ? 2 : 1;
  return {
    used: owned.length,
    limit,
    canCreate: owned.length < limit,
    isEnterprise,
  };
}

/** Organization workspaces the user belongs to (any role), for the switcher. */
export function orgWorkspaces(memberships: Membership[]): Membership[] {
  return memberships.filter((m) => m.kind === 'ORGANIZATION');
}
